interface StatsBarProps {
  stats: { value: string; label: string }[];
}

export default function StatsBar({ stats }: StatsBarProps) {
  return (
    <section className="bg-secondary-500 py-12 md:py-16">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, i) => (
            <div key={i} className="text-center group">
              <p className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-background-50 font-heading tracking-tight leading-none">
                {stat.value}
              </p>
              <div className="mx-auto mt-3 w-8 h-0.5 bg-primary-500/40 group-hover:bg-primary-500/70 transition-colors duration-300"></div>
              <p className="mt-3 text-sm md:text-base text-background-50/65 font-medium tracking-wide">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}